var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:[`tag-${_vm.tagType}`, { show: _vm.label > 0 }]},[_vm._v(" "+_vm._s(_vm._f("labelText")(_vm.label))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }